import React, { useEffect } from 'react';
import { FormLayoutComposer, IFormLayoutProps } from 'components/common/form/renderer/FormLayoutComposer';
import { useParams } from 'react-router-dom';
import toast from 'app/toast';
import useBundleTranslation from 'i18n';

export default function FolderForm(props: IFormLayoutProps) {
    const { t } = useBundleTranslation(['app/notification/folder']);
    const urlParams = useParams();
    useEffect(() => {
        const realFolderId = props.hookForm.form.hookFormGetValues('folder_id');
        const requestFolderId = urlParams['folderId'];

        if (realFolderId != requestFolderId) {
            window.history.replaceState(
                null,
                document.title,
                window.location.pathname.replace(/\d+/, realFolderId) + window.location.search + window.location.hash,
            );
            toast('info', t('editor_top_level'));
        }
    }, []);

    return <FormLayoutComposer props={props} />;
}
